import DocumentoPastaAcao from "./acesso/DocumentoPastaAcao";
import Documento from "./Documento";

export class DocumentoPasta {
    id: number;
    nome: string;
    pastaMae: DocumentoPasta | null;
    pastas: DocumentoPasta[] = [];
    documentos: Documento[] = []; 
    status: string;
    acessoAplicaSubpastas : boolean;
	temAlgumAcesso : boolean;
    acoesUsuarioLogado: DocumentoPastaAcao[] = []

    constructor(
        id: number,
        nome: string,
        pastaMae: DocumentoPasta | null = null,
        status: string = 'CRIADA',
        acessoAplicaSubpastas: boolean = false,
        temAlgumAcesso: boolean = false

    ) {
        this.id = id;
        this.nome = nome;
        this.pastaMae = pastaMae;
        this.status = status;
        this.acessoAplicaSubpastas = acessoAplicaSubpastas;
        this.temAlgumAcesso = temAlgumAcesso;
    }
}